// @flow

import { AppListingTabs, DEFAULT_TAB } from '@atlassian/mpac-app-listing';
import { HostingQueryParamToHostingType } from '@atlassian/mpac-types';
import { useParams, useValidateQueryParams } from '@atlassian/mpac-ui';
import invariant from 'invariant';
import React from 'react';

import SEOFriendlyRedirect from '../../../../../../../common/components/SEOFriendlyRedirect';
import { AllHostingTypeQueryParams, showOnlyPublicQueryParam } from '../../../../../../constants';
import codeSplitComponentFactory from '../../../../../common/codeSplitComponentFactory';
import BaseRouteHandler from '../../../common/routeHandlers/BaseRouteHandler';

const APPS_ROUTE_PARAM_VALIDATION = {
  tab: {
    defaultValue: DEFAULT_TAB,
    validate: value => AppListingTabs.includes(value),
  },
  hosting: {
    defaultValue: undefined,
    validate: value => {
      if (typeof value !== 'undefined') return AllHostingTypeQueryParams.includes(value);
      return true;
    },
  },
  [showOnlyPublicQueryParam]: {
    defaultValue: undefined,
    validate: value => {
      if (value === null) return true;
      if (typeof value !== 'undefined') return Boolean(value).toString() === value;
      return true;
    },
  },
};

const AppsRoute = () => {
  const AppListingPage = codeSplitComponentFactory(() =>
    import(/* webpackPrefetch: true, webpackChunkName: "chunk-app-listing" */ './AppListingPage').then(
      c => c.default
    )
  );

  const params = useParams();
  const { redirectRoute, queryParams } = useValidateQueryParams(APPS_ROUTE_PARAM_VALIDATION);

  if (redirectRoute) {
    return <SEOFriendlyRedirect to={redirectRoute} statusCode={301} />;
  }

  invariant(params.appId, 'App id is required');

  return (
    <BaseRouteHandler includeSearch includeFooter={false}>
      <AppListingPage
        appId={params.appId}
        selectedHosting={HostingQueryParamToHostingType[queryParams.hosting]}
        tab={queryParams.tab}
        showOnlyPublic={queryParams[showOnlyPublicQueryParam] === 'true'}
      />
    </BaseRouteHandler>
  );
};

export default AppsRoute;
